import { DECLINE_ONBOARDING, FETCH_ONBOARDING } from "./actionTypes";

export const fetchOnboarding = () => ({
    type: FETCH_ONBOARDING,
    payload: {}
});

export const declineOnboarding = () => ({
    type: DECLINE_ONBOARDING,
    payload: {},
    errors: null
})